import { LegalDocument } from "@/components/LegalDocument";
import { Seo } from "@/components/Seo";
import blocks from "@/legal/terms.json";

const Terms = () => (
  <>
    <Seo
      title="Terms & Conditions — DELSHA"
      description="The official DELSHA Terms & Conditions — bookings, payments, cancellations, refunds, accounts and instructor responsibilities."
    />
    <LegalDocument blocks={blocks} testId="terms" />
  </>
);

export default Terms;
